import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Form, FormGroup } from "react-bootstrap";

import { useAuth } from "../context/AuthContext";
import { loginUser } from "../api/Auth";
import { routes } from "../Router";
import NavBar from "./common/components/NavBar";

export default function Login(): React.JSX.Element {
  const navigate = useNavigate();

  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const { login } = useAuth();

  React.useEffect(() => {
    /**
     * If already authenticated, redirect to homepage.
     */
    const token = localStorage.getItem("token");
    if (token) {
      navigate(routes.root);
    }
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    await loginUser(username, password)
      .then((token) => login(token))
      .catch((error) => setError(error.message || "Er is iets fout gegaan."));
  };

  return (
    <Container
      fluid={true}
      className="w-100 min-h-100vh d-flex flex-column"
      style={{ maxWidth: "30rem" }}
    >
      <NavBar />
      <Form
        className="d-flex flex-column flex-grow-1 justify-content-between align-items-center mt-3"
        onSubmit={handleLogin}
      >
        <div className="w-100">
          <h3 className="text-start mb-3">Login</h3>
          <FormGroup className="mb-4">
            <Form.Label htmlFor="email">
              <h5 className="mb-0">E-mailadres</h5>
            </Form.Label>
            <Form.Control
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required={true}
              id="email"
            />
            <Form.Text muted={true}>Je Bridgegap e-mailadres.</Form.Text>
          </FormGroup>
          <FormGroup className="mb-4">
            <Form.Label htmlFor="password">
              <h5 className="mb-0">Wachtwoord</h5>
            </Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required={true}
              id="password"
            />
            <Form.Text muted={true}>
              <a className="text-muted" href="mailto:contact@doorway.nl">
                Wachtwoord vergeten?
              </a>
            </Form.Text>
          </FormGroup>
          <div className="d-flex w-100 align-items-center justify-content-between mt-4">
            {error ? (
              <Form.Text className="text-danger mb-1">{error}</Form.Text>
            ) : (
              <div></div>
            )}
            <Button
              title="Inloggen"
              type="submit"
              variant="primary"
              className="px-4"
              disabled={!username || !password}
            >
              Inloggen
            </Button>
          </div>
        </div>
      </Form>
    </Container>
  );
}
